import React from 'react';

export const Select = ({ children, className = '', ...props }) => (
  <div className={`relative ${className}`} {...props}>
    {children}
  </div>
);

export const SelectTrigger = ({ children, ...props }) => (
  <button className="w-full border rounded px-4 py-2" {...props}>
    {children}
  </button>
);

export const SelectContent = ({ children, className = '', ...props }) => (
  <div className={`absolute z-10 bg-white border rounded shadow ${className}`} {...props}>
    {children}
  </div>
);

export const SelectValue = ({ children, ...props }) => <span {...props}>{children}</span>;

export const SelectItem = ({ children, onClick, ...props }) => (
  <div
    onClick={onClick}
    className="px-4 py-2 cursor-pointer hover:bg-gray-100"
    {...props}
  >
    {children}
  </div>
);
